export const SET_DASHBOARD = 'SET_DASHBOARD'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js